import React from 'react';


let lastId = 0;

export default () => {
  const [id, setId] = React.useState();
  
  if (!id) {
    const createId = ++lastId;
    
    setId(createId);
    
    return ':' + createId + ':';
  }
  
  return ':' + id + ':';
};
